import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import isEqual from 'lodash/isEqual'

import { setProject, setConfig } from '../../obj/pscState'

import useAuthentication from '../../hooks/useAuthentication';
import { useInterval } from '../../hooks/useInterval'

const ReloadProject = () => {
    const [reloadAlert, setReloadAlert] = useState(false)
    const [connectionAlert, setConnectionAlert] = useState(false)
    const [offlineAlert, setOfflineAlert] = useState(false)
    const [initialTimestamp, setInitialTimestamp] = useState(undefined)

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const pscState = useSelector(state => state.pscState.value)
    const project = pscState.project
    const config = pscState.config || {}

    const { currentUser, updateUser, logout } = useAuthentication();
    
    /* TODO This is wank. websockets???? */
    useEffect(() => {
        // Do one initial load. but not on the project
        reload()
    }, [])

//    useInterval(() => {
//        checkOffline()
//    }, 1000 * 9)

    useInterval(() => {
        reload()
    }, 1000 * 30)

    useInterval(() => {
        reloadProject()
    }, 1000 * 60 * 5)

//    const checkOffline = () => {
//        if( window.navigator.onLine === false ) {
//            setOfflineAlert(true)
//            return
//        }
//        setOfflineAlert(false)
//    }
    
    const reload = () => {
        if( offlineAlert ) {
            return
        }

        fetch('/timestamp.js?cachebust='+Date.now(), { credentials: 'same-origin' })
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
                const timestamp = json.timestamp
                if( initialTimestamp === undefined ) {
                    setInitialTimestamp( timestamp )
                    return
                }

                if( initialTimestamp !== timestamp ) {
                    setInitialTimestamp( timestamp )
                    setReloadAlert( true )
                }
//                setConnectionAlert(false)
            })
            .catch(error => {
                console.log("Timestamp fetch error", error)
//                setConnectionAlert(true)
            })

        if (typeof currentUser === 'undefined' || currentUser.id === 0 || typeof currentUser.id === 'undefined' ) {
            return
        }

        reloadUser(() =>
            reloadConfig()
        )
    }
    
    const reloadUser = (cb) => {
        fetch('/v0/users/' + currentUser.id, { credentials: 'same-origin' })
            .then(function(response) {
                if( response.status === 403 ) {
                    // They're logged out server-side; make sure that's true on client too
                    logout();
                    throw new Error(response.statusText)
                }
                return response.json()
            })
            .then(function(json) {
                if( ! json ) {
                    return
                }

                const reloadedUser = json.result
                if( !isEqual(reloadedUser, currentUser) ) {
                    updateUser(reloadedUser);
                }

                if(cb) {
                    cb()
                }
            })
            .catch(error => console.log(error))
    }

    const reloadConfig = (cb) => {
        fetch('/v0/config', { credentials: 'same-origin' })
            .then(function(response) {
                if( response.status === 403 ) {
                    // They're logged out server-side; make sure that's true on client too
                    logout();
                    throw new Error(response.statusText)
                }
                return response.json()
            })
            .then(function(json) {
                if (!isEqual(json, config)) {
                    dispatch(setConfig(json))
                }
                if(cb) {
                    cb()
                }
            })
            .catch(error => console.log(error))
    }
    
    const reloadProject = () => {
        if (typeof currentUser === 'undefined' || currentUser === 0) {
            return
        }
        
        if ( ! project || typeof project.id === 'undefined' ) {
            return
        }

        fetch('/v0/projects/' + project.id, { credentials: 'same-origin' })
            .then(function(response) {
                if( response.status === 403 ) {
                    // They're logged out server-side; make sure that's true on client too
                    logout();
                    throw new Error(response.statusText)
                }
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                if (!isEqual(json.result, project)) {
                    dispatch(setProject(json.result))
                }
            })
            .catch(error => console.log(error))
    }
    
    const reloadPage = (e) => {
        if( e ) {
            e.preventDefault()
        }
        window.location.reload()
    }

    if( offlineAlert ) {
        return (
            <div className="alert alert-danger" style={{position: 'absolute', zIndex: '100000', top: '0px', left: '300px'}}>
                It appears you are offline. Please check your internet connection.
            </div>
        )
    }

    if( connectionAlert ) {
        return (
            <div className="alert alert-danger" style={{position: 'absolute', zIndex: '100000', top: '0px', left: '300px'}}>
                Connection interrupted! <a className="alert-link" onClick={reloadPage}>Please click here to reload the page.</a>
            </div>
        )
    }

    if( reloadAlert ) {
        return (
            <div className="alert alert-danger" style={{position: 'absolute', zIndex: '100000', top: '0px', left: '300px'}}>
                Updates are available! <a className="alert-link" onClick={reloadPage}>Please click here to reload the page.</a>
            </div>
        )
    }
    
    return (
        <div />
    )
};

export default ReloadProject
